<div class="context-view">
  <div class="context-title">{{ 'MASTERDATA.LOADUNIT.LIST.TITLE' | translate }}</div>
  @if (!isLoading()) {
    <dx-data-grid
      id="loadunit-grid"
      [dataSource]="loadunits()"
      [showRowLines]="true"
      [showColumnLines]="false"
      [showBorders]="true"
      [keyExpr]="['id']"
      [allowColumnReordering]="false"
      [allowColumnResizing]="false"
      (onRowDblClick)="loadLoadunit($event)"
      style="width: 100%"
      height="100%">
      <dxo-scrolling
        mode="infinite"
        [useNative]="false"
        [scrollByContent]="true"
        [scrollByThumb]="true"
        showScrollbar="onHover">
      </dxo-scrolling>
      <dxo-search-panel [visible]="true" [highlightCaseSensitive]="false"> </dxo-search-panel>
      <dxo-selection mode="multiple" showCheckBoxesMode="none"></dxo-selection>

      <dxo-toolbar>
        <dxi-item name="searchPanel" location="before"></dxi-item>
        <dxi-item location="after">
          <dx-button [icon]="'add'" class="button-add" (onClick)="addLoadunit()"> </dx-button>
        </dxi-item>
      </dxo-toolbar>

      <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>

      <dxi-column
        dataField="id"
        [caption]="'MASTERDATA.LOADUNIT.DTO.ID' | translate"
        [allowSorting]="true"
        [calculateCellValue]="utilService.asString">
        <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
      </dxi-column>

      <dxi-column dataField="name" [caption]="'MASTERDATA.LOADUNIT.DTO.NAME' | translate" [allowSorting]="true">
      </dxi-column>

      <dxi-column
        dataField="type"
        [caption]="'MASTERDATA.LOADUNIT.DTO.TYPE' | translate"
        [allowSorting]="true"
        [calculateCellValue]="utilService.asStringTranslated('MASTERDATA.LOADUNIT.DTO.TYPE_')">
      </dxi-column>

      <dxi-column dataField="maxLoad" [caption]="'MASTERDATA.LOADUNIT.DTO.MAXLOAD' | translate" [allowSorting]="true">
        <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
      </dxi-column>

      <dxi-column
        dataField="maxVolume"
        [caption]="'MASTERDATA.LOADUNIT.DTO.MAXVOLUME' | translate"
        [allowSorting]="true">
        <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
      </dxi-column>
    </dx-data-grid>
  } @else {
    <app-loader></app-loader>
  }
</div>
